import { API_URL_FACTORY } from '@factories/apiUrlFactory'

export const proposalService = async (regNo, mobileNo = '') => {
  try {
    const proposalData = API_URL_FACTORY.PROPOSAL_FETCH(regNo, mobileNo)
    const response = await fetch(proposalData)
    const data = await response.json()
    return data
  } catch (e) {
    console.error('error fetching deep link', e)
  }
}
